import { render } from "./RolesIframe.vue?vue&type=template&id=7bfa3540&ts=true"
import script from "./RolesIframe.ts?vue&type=script&lang=ts&external"
export * from "./RolesIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__